module.exports = __webpack_public_path__ + "static/Savills_Summer_Cocktail-faa432f70ff82e69c815c159662f94aa.jpg";